export default __webpack_public_path__ + "static/media/Cp_background_Geshikt.f985b647.png";